exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-heading__header[data-v-06641974]{font-size:2rem}", ""]);

// exports
